import { combineReducers } from "redux";

import totaleffects from "../features/admin/dashboard/totaleffects/Slice";

import totalproducts from "../features/admin/dashboard/totalproducts/Slice";

import totalenquirys from "../features/admin/dashboard/totalenquirys/Slice";

import totalcontacts from "../features/admin/dashboard/totalcontacts/Slice";

import common from "../features/admin/common/Slice";

const dashboard = combineReducers({
  totaleffects,
  totalproducts,
  totalenquirys,
  totalcontacts,
  common
});

export default dashboard;
